import React, { Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';
import { useIsAuthenticated } from '@azure/msal-react';
import PreLoaderWidget from 'components/Loader';
import VerticalLayout from 'components/AppLayout/Layouts/Vertical';

import ProtectedRoutes from './ProtoctedRoutes';

const Authorization = React.lazy(() => import('routes/Authorization'));

const Routes = () => (
    <Suspense fallback={<PreLoaderWidget />}>
        <Switch>
            <Route path="/account" component={Authorization} />
            {process.env.AZURE_SSO_LOGIN_ENABLED === 'true' && useIsAuthenticated && (
                <VerticalLayout>
                    <ProtectedRoutes />
                </VerticalLayout>
            )}
            {localStorage.getItem('token') !== null && process.env.AZURE_SSO_LOGIN_ENABLED === 'false' && (
                <VerticalLayout>
                    <ProtectedRoutes />
                </VerticalLayout>
            )}
        </Switch>
    </Suspense>
);
export default Routes;
